import { Alert, AlertTitle, Box, styled } from '@mui/material';
import { Component, ReactNode } from 'react';

const ErrorContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

const ErrorMessage = styled('pre')(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  overflow: 'auto',
  fontSize: '0.75rem',
}));

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ComponentErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render(): ReactNode {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError && error) {
      return (
        <ErrorContainer>
          <Alert severity='error'>
            <AlertTitle>Component Error</AlertTitle>
            This version encountered an error.
            <ErrorMessage>{error.message}</ErrorMessage>
          </Alert>
        </ErrorContainer>
      );
    }

    return children;
  }
}
